import {
  FormControl,
  Typography,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
} from "@mui/material";
import { isFieldVisible } from "./formUtils";

const TradeTransactionDetails = ({
  formData,
  handleChange,
  errors,
  formMode,
  currentDate,
  formOriginPortList,
  formDeliveryPortList,
  incotermsMaster,
  selectedTradeRFQ,
}) => (
  <div className="tab-pane active">
    <div className="row g-3">
      {isFieldVisible("tradeType", formData.instrument, formData) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view"}
            error={!!formData.errors?.tradeType}
          >
            <Typography variant="body2">Trade Type</Typography>
            {formMode === "view" ? (
              <TextField
                value={formData.tradeType}
                disabled={true}
                sx={{ backgroundColor: "white", width: "100%" }}
                placeholder="category selected"
              />
            ) : (
              <Select
                name="tradeType"
                value={formData.tradeType}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Select Trade Type" }}
                disabled={formMode === "view"}
              >
                <MenuItem value="" disabled>
                  Select Trade Type
                </MenuItem>
                {["Import", "Export", "Domestic"].map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            )}
          </FormControl>
        </div>
      )}
      {isFieldVisible(
        "commodityDescription",
        formData.instrument,
        formData
      ) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view"}
            error={!!errors.commodityDescription}
          >
            <Typography variant="body2">Commodity Description</Typography>

            <TextField
              name="commodityDescription"
              value={formData.commodityDescription}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              placeholder="e.g., Soybeans, Crude Oil, Textiles"
              inputProps={{ "aria-label": "Commodity Description" }}
              disabled={formMode === "view"}
            />
            {errors.commodityDescription && (
              <FormHelperText>{errors.commodityDescription}</FormHelperText>
            )}
          </FormControl>
        </div>
      )}
      {isFieldVisible("hsCode", formData.instrument, formData) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view"}
            error={!!errors.hsCode}
          >
            <Typography variant="body2">HS Code (Optional)</Typography>
            <TextField
              name="hsCode"
              value={formData.hsCode}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              placeholder="e.g., 1201.10"
              inputProps={{ "aria-label": "HS Code" }}
              disabled={formMode === "view"}
            />
            {errors.hsCode && <FormHelperText>{errors.hsCode}</FormHelperText>}
          </FormControl>
        </div>
      )}
      {isFieldVisible("buyerNameCountry", formData.instrument, formData) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view"}
            error={!!errors.buyerNameCountry}
          >
            <Typography variant="body2">Buyer Name & Country</Typography>
            <TextField
              name="buyerNameCountry"
              value={formData.buyerNameCountry}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              placeholder="e.g., Acme Corp, Vietnam"
              inputProps={{ "aria-label": "Buyer Name & Country" }}
              disabled={formMode === "view"}
            />
            {errors.buyerNameCountry && (
              <FormHelperText>{errors.buyerNameCountry}</FormHelperText>
            )}
          </FormControl>
        </div>
      )}
      {isFieldVisible("sellerNameCountry", formData.instrument, formData) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view"}
            error={!!errors.sellerNameCountry}
          >
            <Typography variant="body2">Seller Name & Country</Typography>
            <TextField
              name="sellerNameCountry"
              value={formData.sellerNameCountry}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              placeholder="e.g., Global Traders, Brazil"
              inputProps={{ "aria-label": "Seller Name & Country" }}
              disabled={formMode === "view"}
            />
            {errors.sellerNameCountry && (
              <FormHelperText>{errors.sellerNameCountry}</FormHelperText>
            )}
          </FormControl>
        </div>
      )}
      {isFieldVisible("portLoading", formData.instrument, formData) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view" || !formData.countryOrigin}
            error={!!formData.errors?.portLoading}
          >
            <Typography variant="body2">Port of Loading</Typography>
            {formMode === "view" ? (
              <TextField
                value={formData.portLoading}
                disabled={true}
                sx={{ backgroundColor: "white", width: "100%" }}
                placeholder="category selected"
              />
            ) : (
              <Select
                name="portLoading"
                value={formData.portLoading}
                onChange={handleChange}
                displayEmpty
                sx={{ backgroundColor: "white" }}
                disabled={formMode === "view"}
              >
                <MenuItem value="" disabled>
                  {formData.countryOrigin
                    ? "Select Port of Loading"
                    : "Select Country of Origin First"}
                </MenuItem>
                {Array.isArray(formOriginPortList) &&
                formOriginPortList.length > 0 ? (
                  formOriginPortList.map((option, index) => (
                    <MenuItem key={index} value={option.Value}>
                      {option.Value}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    No ports available
                  </MenuItem>
                )}
              </Select>
            )}
          </FormControl>
        </div>
      )}
      {isFieldVisible("portDischarge", formData.instrument, formData) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view" || !formData.countryDestination}
            error={!!formData.errors?.portDischarge}
          >
            <Typography variant="body2">Port of Discharge</Typography>
            {formMode === "view" ? (
              <TextField
                value={formData.portDischarge}
                disabled={true}
                sx={{ backgroundColor: "white", width: "100%" }}
                placeholder="category selected"
              />
            ) : (
              <Select
                name="portDischarge"
                value={formData.portDischarge}
                onChange={handleChange}
                displayEmpty
                sx={{ backgroundColor: "white" }}
                disabled={formMode === "view"}
              >
                <MenuItem value="" disabled>
                  {formData.countryDestination
                    ? "Select Port of Discharge"
                    : "Select Country of Destination First"}
                </MenuItem>
                {Array.isArray(formDeliveryPortList) &&
                formDeliveryPortList.length > 0 ? (
                  formDeliveryPortList.map((option, index) => (
                    <MenuItem key={index} value={option.Value}>
                      {option.Value}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    No ports available
                  </MenuItem>
                )}
              </Select>
            )}
          </FormControl>
        </div>
      )}
      {isFieldVisible("shipmentDate", formData.instrument, formData) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view"}
            error={!!errors.shipmentDate}
          >
            <Typography variant="body2">Shipment Date (Estimated)</Typography>
            <TextField
              name="shipmentDate"
              type="date"
              value={formData.shipmentDate || currentDate}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              inputProps={{ "aria-label": "Shipment Date" }}
              disabled={formMode === "view"}
            />
            {errors.shipmentDate && (
              <FormHelperText>{errors.shipmentDate}</FormHelperText>
            )}
          </FormControl>
        </div>
      )}
      {isFieldVisible("tradeValue", formData.instrument, formData) && (
        <div className="col-md-4">
          <FormControl
            fullWidth
            disabled={formMode === "view"}
            error={!!errors.tradeValue}
          >
            <Typography variant="body2">
              Trade Value (Invoice Amount)
            </Typography>
            <TextField
              name="tradeValue"
              type="number"
              step="any"
              value={formData.tradeValue}
              onChange={handleChange}
              size="small"
              sx={{ backgroundColor: "white" }}
              placeholder="e.g., 95000"
              inputProps={{ "aria-label": "Trade Value" }}
              disabled={formMode === "view"}
            />
            {errors.tradeValue && (
              <FormHelperText>{errors.tradeValue}</FormHelperText>
            )}
          </FormControl>
        </div>
      )}
    </div>
  </div>
);

export default TradeTransactionDetails;
